import { Injectable, Inject } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, concat } from 'rxjs';
import { DOCUMENT, Location } from '@angular/common';
import { IUserRoleDetails } from 'src/app/models/user-role-details';
import { IUserDetails } from 'src/app/models/user';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from 'src/app/services/core/authentication/authentication.service';
import { ConfigurationSettings } from 'src/app/models/configuration.settings';
import { UserService } from 'src/app/services/core/user/user.service';
import { DataService } from 'src/app/services/shared/data/data.service';
import { CommunicationService } from 'src/app/services/shared/communication/communication.service';
import { ConnectedStatusService } from 'src/app/services/shared/connection-status/connected-status.service';
import { MatDialog } from '@angular/material';
import { PrivacyStatementComponent } from '../../components/shared/privacy-statement/privacy-statement.component';
import { PrivacyacceptanceService } from '../../services/shared/privacyacceptance/privacyacceptance.service';
import * as Msal from 'msal';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  private path: string;
  public tokenValue: any;
  private IdaasConfig: any;
  private AdAuthConfig: any;
  private locationUrl: any;
  public hilUrl: string;
  public userRoleDetails: IUserRoleDetails[] = [];
  public userDetails: IUserDetails;
  public msalInstance: any;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    @Inject(DOCUMENT) private document: Document,
    private httpClient: HttpClient,
    private configurationSettings: ConfigurationSettings,
    private location: Location,
    private userService: UserService,
    private dataService: DataService,
    private communication: CommunicationService,
    private connectedStatusService: ConnectedStatusService,
    private dialogPrivacyStatement: MatDialog,
    private privacyacceptanceService: PrivacyacceptanceService,
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let isActivated = this.isAuthenticatedUser(next);
    return isActivated;
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let isActivated = this.isAuthenticatedUser(next);
    return isActivated;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }

  private isAuthenticatedUser(route: ActivatedRouteSnapshot) {
    this.locationUrl = this.location;
    this.configurationSettings.hostUrl = this.locationUrl._platformLocation.location.origin;

    if (!this.configurationSettings.hilUrl || this.configurationSettings.hilUrl == '') {
      this.configurationSettings.hilUrl = sessionStorage.getItem('hilUrl');
    }

    //always authenticate when user navigates to Login component ("")
    if (route.routeConfig.path == "") {
      sessionStorage.clear();
      localStorage.clear();
      //this.communication.deleteHubConnection();
    }

    //get token from sessionStorage
    const token = sessionStorage.getItem('access_token');
    const code = sessionStorage.getItem('code');

    if (!sessionStorage.getItem('path')) {
      sessionStorage.setItem('path', route.routeConfig.path);

    }

    if (token) {
      this.dataService.sendUsername(localStorage.getItem('userName'));
      this.privacyacceptanceService.sendPrivacyAcceptance(false);
      return true;
    }
    
    else {
      this.authenticationService.getAdAuthConfiguration()
        .subscribe(
          res => {
            this.AdAuthConfig = res;
            if (this.AdAuthConfig) {
              sessionStorage.setItem('hilUrl', this.AdAuthConfig["HILURL"]);//store the hilUrl
              var adClientId = this.AdAuthConfig["AdClientId"];
              var adAuthority = this.AdAuthConfig["AdAuthority"]; 
              this.authenticateADUser(adClientId, adAuthority);
              }
          },
          (error) => {
          }
        )
    }
  }
  private authenticateADUser(adClientId, adAuthority) {
    const msalConfig = {
      auth: {
        clientId: adClientId,
        authority: 'https://login.microsoftonline.com/' + adAuthority
      },
    };
    this.msalInstance = new Msal.UserAgentApplication(msalConfig);
    this.msalInstance.handleRedirectCallback((error, response) => {
      // handle redirect response or error
      console.log(error);
     });

    let loginRequest = {
      scopes: ["user.read", 'openid', 'profile']
    };
    this.msalInstance.loginPopup(loginRequest)
      .then(response => {
        sessionStorage.setItem('access_token', response.idToken.rawIdToken);
        this.path = sessionStorage.getItem('path');
        this.SetAuthenticatedUser();
      })
      .catch(err => {
        // handle error
      });
  }
  private setUser() {
     this.userService.getLoggedInUserRoles()
      .subscribe(
        result => {
          if (result) {
            this.userRoleDetails = result;
            sessionStorage.setItem('userBotRoles', JSON.stringify(this.userRoleDetails));
            sessionStorage.setItem('userEmailId', this.userRoleDetails[0].username);
            sessionStorage.setItem('userName', this.userRoleDetails[0].firstname);
            localStorage.setItem('userFullName', this.userRoleDetails[0].firstname + " " + this.userRoleDetails[0].lastname);
            this.dataService.sendUsername(this.userRoleDetails[0].firstname);
            let agent = this.userRoleDetails.filter(x => x.role.toLowerCase() === 'agent');
            let resultArray = this.userRoleDetails.map(x => x.role).join(",");
            sessionStorage.setItem('userRoles', resultArray.toString());
            this.dataService.sendUsername(sessionStorage.getItem('userName'));
            if (agent && agent.length > 0) {//if user type is Agent then create hubconnection
              this.configurationSettings.userRole = 'Agent';
              if (!localStorage.getItem("agentConnected") || localStorage.getItem("agentConnected") != 'true') {
                this.communication.CreateAgentConnection(sessionStorage.getItem('userEmailId'));
              }
            }
            this.router.navigate(['/home']);
          }
        },
        (error) => {
        });
  }

  private SetAuthenticatedUser() {
    this.userService.getLoggedInUserRoles()
      .subscribe(
        result => {
          if (result) {
            this.userRoleDetails = result;
            sessionStorage.setItem('userBotRoles', JSON.stringify(this.userRoleDetails));
            localStorage.setItem('userEmailId', this.userRoleDetails[0].username);
            localStorage.setItem('userName', this.userRoleDetails[0].firstname);
            localStorage.setItem('userFullName', this.userRoleDetails[0].firstname + " " + this.userRoleDetails[0].lastname);

            sessionStorage.setItem('userEmailId', this.userRoleDetails[0].username);
            sessionStorage.setItem('userName', this.userRoleDetails[0].firstname);
            sessionStorage.setItem('userFullName', this.userRoleDetails[0].firstname + " " + this.userRoleDetails[0].lastname);
            this.dataService.sendUsername(this.userRoleDetails[0].firstname);
            let agent = this.userRoleDetails.filter(x => x.role.toLowerCase() === 'agent');
            let seniorAgent = this.userRoleDetails.filter(ob => ob.role.toLowerCase() === 'senioragent' || ob.role.toLowerCase() === 'senior agent');
            let chatManager = this.userRoleDetails.filter(ob => ob.role.toLowerCase() === 'chatmanager' || ob.role.toLowerCase() === 'chat manager');
            let resultArray = this.userRoleDetails.map(x => x.role).join(",");
            sessionStorage.setItem('userRoles', resultArray.toString());
            this.dataService.sendUsername(sessionStorage.getItem('userName'));
            if (JSON.parse(sessionStorage.getItem('privacyStatementFlag')) == null && !this.userRoleDetails[0].privacyStatementFlag) {
              if ((agent && agent.length > 0) || (seniorAgent && seniorAgent.length > 0)) {//if user type is Agent then create hubconnection
                this.configurationSettings.userRole = agent && agent.length > 0 ? 'Agent' : 'Senior Agent';
                if (!localStorage.getItem("agentConnected") || localStorage.getItem("agentConnected") != 'true') {
                  this.communication.CreateAgentConnection(localStorage.getItem('userEmailId'));
                }
              }

              if ((chatManager && chatManager.length > 0) ) {//if user type is Chat Manager then create hubconnection
                this.configurationSettings.userRole = 'Chat Manager' ;
                if (!localStorage.getItem("agentConnected") || localStorage.getItem("agentConnected") != 'true') {
                  this.communication.CreateAgentConnection(localStorage.getItem('userEmailId'));
                }
              }

            }

            this.router.navigate(['/home']);

            if (this.userRoleDetails[0].privacyStatementFlag) {
              this.showPrivacyStatement();
            } else {
              sessionStorage.setItem('privacyStatementFlag', "false");
              this.privacyacceptanceService.sendPrivacyAcceptance(false);
            }
          }
        },
        (error) => {
          console.log(error);
        })
  }

  showPrivacyStatement() {
    let dialogRef = this.dialogPrivacyStatement.open(PrivacyStatementComponent, {
      height: '75%',
      width: '80%',
      autoFocus: false,
      data: null,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

    })
  }
}
